<div
    class="w-full min-h-0 flex flex-col items-center justify-start px-4 sm:px-6 flex-1 overflow-y-auto scrollbar-transparent">
    <h2
        class="text-2xl font-semibold tracking-tight text-balance text-primary sm:text-4xl md:text-5xl text-center sm:text-left use-grotesque">
        What are you
        <span class="bg-gradient-to-r from-primary to-brand-studio bg-clip-text text-transparent">promoting?</span>
    </h2>
    <p class="mx-auto mt-2 max-w-xl text-base sm:text-lg/8 text-pretty text-secondary text-center sm:text-left">Just the
        basics - Our AI will do the heavy lifting.</p>


    @if (!queryRunning() && !slickOnboardService.stepsHtml() && !savingBrief()) {
    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">

        <div class="grid grid-cols-1 gap-x-6 gap-y-5 sm:gap-y-6 sm:grid-cols-6">

            <!-- Brief Title -->
            <div class="sm:col-span-6">
                <label for="brief-title" class="block text-sm/6 font-medium text-primary">Brief title</label>
                <div class="mt-2 grid grid-cols-1">
                    <input [formField]="slickOnboardService.promotingForm.briefTitle" id="brief-title" type="text"
                        placeholder="Brief title"
                        [class.input-invalid]="slickOnboardService.promotingForm.briefTitle().touched() && slickOnboardService.promotingForm.briefTitle().invalid()"
                        class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4">
                        <path
                            d="M11.35 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v5.35" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="M14 19h6" />
                        <path d="M17 16v6" />
                    </svg>
                </div>
                @if (slickOnboardService.promotingForm.briefTitle().touched() &&
                slickOnboardService.promotingForm.briefTitle().invalid()) {
                <ul class="error-list">
                    @for (error of slickOnboardService.promotingForm.briefTitle().errors(); track error) {
                    <li class="text-error-light flex items-start gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                            class="shrink-0 mt-0.5" aria-hidden="true">
                            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                            <path d="M12 9v4" />
                            <path d="M12 17h.01" />
                        </svg>
                        {{ error.message }}
                    </li>
                    }
                </ul>
                }
            </div>
            <!-- Brief Title - END -->

            <!-- Promotion choice: My Brand vs Specific Product -->
            <div class="sm:col-span-6">
                <span class="block text-sm/6 font-medium text-primary">What would you like to promote?</span>
                <div class="mt-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
                    <button type="button" (click)="selectMyBrand()" [attr.aria-pressed]="productChoice() === 'myBrand'"
                        class="flex w-full items-center gap-3 rounded-lg p-4 text-left transition-colors touch-manipulation"
                        [class]="productChoice() === 'myBrand'
                            ? 'border-2 border-primary bg-primary/5 shadow-sm dark:bg-primary/10'
                            : 'border border-gray-200 bg-white hover:border-primary/50 dark:border-white/10 dark:bg-zinc-800/50'">
                        @if (focussedBrand?.companyLogo || brandProduct()?.productImage) {
                        <img [src]="imageService.getImageSource(focussedBrand?.companyLogo || brandProduct()?.productImage, 'gallery')"
                            alt=""
                            class="size-10 shrink-0 rounded-full object-cover ring-1 ring-gray-200 dark:ring-white/10"
                            aria-hidden="true" />
                        } @else {
                        <span
                            class="flex size-10 shrink-0 items-center justify-center rounded-full bg-gray-100 text-sm font-semibold text-accent dark:bg-zinc-700"
                            aria-hidden="true">
                            {{ (focussedBrand?.companyName || 'B').charAt(0).toUpperCase() }}
                        </span>
                        }
                        <span class="min-w-0">
                            <p class="m-0 text-sm font-semibold text-primary">My Brand</p>
                            <p class="m-0 mt-0.5 truncate text-xs text-secondary">{{ focussedBrand?.companyName ||
                                'Promote your whole brand' }}</p>
                        </span>
                    </button>
                    <button type="button" (click)="selectSpecificProduct()"
                        [attr.aria-pressed]="productChoice() === 'specific'"
                        class="flex w-full items-center gap-3 rounded-lg p-4 text-left transition-colors touch-manipulation"
                        [class]="productChoice() === 'specific'
                            ? 'border-2 border-primary bg-primary/5 shadow-sm dark:bg-primary/10'
                            : 'border border-gray-200 bg-white hover:border-primary/50 dark:border-white/10 dark:bg-zinc-800/50'">
                        <span
                            class="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 dark:bg-primary/20"
                            aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-accent">
                                <path
                                    d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
                                <path d="m3.3 7 8.7 5 8.7-5" />
                                <path d="M12 22V12" />
                            </svg>
                        </span>
                        <span class="min-w-0">
                            <p class="m-0 text-sm font-semibold text-primary">Specific Product</p>
                            <p class="m-0 mt-0.5 text-xs text-secondary">A specific product you offer</p>
                        </span>
                    </button>
                </div>
            </div>
            <!-- Promotion choice - END -->

            @if (productChoice() === 'myBrand') {
            <!-- Brand summary -->
            <div class="sm:col-span-6">
                <label class="block text-sm/6 font-medium text-primary">Promoting</label>
                <div
                    class="mt-2 w-full rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4">
                    @if (loadingBrandProduct()) {
                    <div class="flex items-center gap-3 text-secondary">
                        <svg aria-hidden="true"
                            class="w-5 h-5 text-gray-400 dark:text-gray-500 animate-spin fill-primary dark:fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                        <span class="text-sm">Loading your brand…</span>
                    </div>
                    } @else if (brandProduct()) {
                    <div class="flex items-center gap-4">
                        @if (focussedBrand?.companyLogo || brandProduct()?.productImage) {
                        <img [src]="imageService.getImageSource(focussedBrand?.companyLogo || brandProduct()?.productImage, 'gallery')"
                            alt="Brand logo" class="h-14 w-14 rounded-md object-cover" />
                        }
                        <div>
                            <h4 class="text-md font-bold text-primary">{{ focussedBrand?.companyName ||
                                brandProduct()?.productName }}</h4>
                            <p class="mt-1 text-sm text-secondary">Promoting your whole brand — our AI will build the
                                brief
                                around your brand.</p>
                        </div>
                    </div>
                    } @else {
                    <p class="text-sm text-secondary">We couldn't load your brand product. Please try again or choose
                        <button type="button" (click)="selectSpecificProduct()"
                            class="font-semibold text-accent hover:text-primary/85">Specific Product</button>.
                    </p>
                    }
                </div>
            </div>
            <!-- Brand summary - END -->
            }

            @if (productChoice() === 'specific') {
            <!-- Product -->
            <div class="sm:col-span-6">
                <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                    <label for="product-link" class="block text-sm/6 font-medium text-primary">Product to
                        promote</label>
                    @if (manualProductEntry()) {
                    <button type="button" (click)="useProductLinkEntry()"
                        class="self-start text-sm font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85 touch-manipulation">
                        Use a product link instead
                    </button>
                    }
                </div>

                @if (!manualProductEntry()) {
                <div class="w-full flex flex-row gap-x-4 items-center">
                    <div class="flex-1 mt-2 grid grid-cols-1">
                        <input [formField]="slickOnboardService.promotingForm.productLink" id="product-link" type="text"
                            placeholder="Product link"
                            class="col-start-1 row-start-1 block input-icon text-primary text-base min-h-11" />
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 dark:text-gray-400 sm:size-4"
                            aria-hidden="true">
                            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
                        </svg>
                    </div>

                    @if (findingProductDetails()) {
                    <div class="flex items-center justify-center w-8 h-8">
                        <svg aria-hidden="true"
                            class="mx-auto w-6 h-6 text-gray-400 dark:text-gray-500 animate-spin fill-primary dark:fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                    </div>
                    }
                </div>
                <p class="mt-1 text-xs leading-6 text-secondary">Paste the link to the product, we'll find the details
                    for you.</p>
                <button type="button" (click)="useManualProductEntry()"
                    class="mt-2 text-sm font-semibold text-accent hover:text-primary/85 dark:hover:text-primary/85 touch-manipulation">
                    No product link? Enter details manually
                </button>
                } @else {
                <p class="mt-2 text-sm leading-6 text-secondary">Add your product yourself. We will use this for your
                    brief and creator matching.</p>
                <div class="mt-4 grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-6">
                    <div class="sm:col-span-6">
                        <label for="manual-product-name" class="block text-sm/6 font-medium text-primary">Product
                            name</label>
                        <div class="mt-2">
                            <input [formField]="slickOnboardService.productDetailsForm.productName" id="manual-product-name"
                                type="text" placeholder="Product name"
                                [class.input-invalid]="slickOnboardService.productDetailsForm.productName().touched() && slickOnboardService.productDetailsForm.productName().invalid()"
                                class="block w-full input-primary text-primary text-base min-h-11" />
                        </div>
                        @if (slickOnboardService.productDetailsForm.productName().touched() &&
                        slickOnboardService.productDetailsForm.productName().invalid()) {
                        <ul class="error-list mt-1">
                            @for (error of slickOnboardService.productDetailsForm.productName().errors(); track error) {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                    <div class="sm:col-span-6">
                        <label for="manual-product-description" class="block text-sm/6 font-medium text-primary">Product
                            description</label>
                        <div class="mt-2">
                            <textarea [formField]="slickOnboardService.productDetailsForm.productDescription"
                                id="manual-product-description" rows="4" placeholder="What should creators know?"
                                [class.input-invalid]="slickOnboardService.productDetailsForm.productDescription().touched() && slickOnboardService.productDetailsForm.productDescription().invalid()"
                                class="block w-full input-textarea text-primary resize-y min-h-24"></textarea>
                        </div>
                        @if (slickOnboardService.productDetailsForm.productDescription().touched() &&
                        slickOnboardService.productDetailsForm.productDescription().invalid()) {
                        <ul class="error-list mt-1">
                            @for (error of slickOnboardService.productDetailsForm.productDescription().errors(); track
                            error) {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                    <div class="sm:col-span-3">
                        <label for="manual-product-price" class="block text-sm/6 font-medium text-primary">Price
                            (number)</label>
                        <div class="mt-2">
                            <input [formField]="slickOnboardService.productDetailsForm.productPrice"
                                id="manual-product-price" type="text" inputmode="decimal" placeholder="0.00"
                                [class.input-invalid]="slickOnboardService.productDetailsForm.productPrice().touched() && slickOnboardService.productDetailsForm.productPrice().invalid()"
                                class="block w-full input-primary text-primary text-base min-h-11" />
                        </div>
                        @if (slickOnboardService.productDetailsForm.productPrice().touched() &&
                        slickOnboardService.productDetailsForm.productPrice().invalid()) {
                        <ul class="error-list mt-1">
                            @for (error of slickOnboardService.productDetailsForm.productPrice().errors(); track error)
                            {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                    <div class="sm:col-span-3">
                        <label for="manual-product-currency" class="block text-sm/6 font-medium text-primary">Currency
                            code</label>
                        <div class="mt-2">
                            <input [formField]="slickOnboardService.productDetailsForm.currency"
                                id="manual-product-currency" type="text" placeholder="gbp"
                                [class.input-invalid]="slickOnboardService.productDetailsForm.currency().touched() && slickOnboardService.productDetailsForm.currency().invalid()"
                                class="block w-full input-primary text-primary text-base min-h-11" />
                        </div>
                        @if (slickOnboardService.productDetailsForm.currency().touched() &&
                        slickOnboardService.productDetailsForm.currency().invalid()) {
                        <ul class="error-list mt-1">
                            @for (error of slickOnboardService.productDetailsForm.currency().errors(); track error) {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                    <div class="sm:col-span-6">
                        <span class="block text-sm/6 font-medium text-primary">Product image</span>
                        <div class="mt-2 max-w-xs w-fit"
                            [class.input-invalid]="slickOnboardService.productDetailsForm.productImage().touched() && slickOnboardService.productDetailsForm.productImage().invalid()">
                            <atom-add-image [initialImage]="slickOnboardService.productDetailsModel().productImage"
                                [bucket]="S3BucketEnum.PRODUCT_IMAGES" [size]="'sm'"
                                (imageUploaded)="onImageUploaded($event)"></atom-add-image>
                        </div>
                        @if (slickOnboardService.productDetailsForm.productImage().touched() &&
                        slickOnboardService.productDetailsForm.productImage().invalid()) {
                        <ul class="error-list mt-1">
                            @for (error of slickOnboardService.productDetailsForm.productImage().errors(); track error)
                            {
                            <li class="text-error-light flex items-start gap-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                                    stroke-linejoin="round" class="shrink-0 mt-0.5" aria-hidden="true">
                                    <path
                                        d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3" />
                                    <path d="M12 9v4" />
                                    <path d="M12 17h.01" />
                                </svg>
                                {{ error.message }}
                            </li>
                            }
                        </ul>
                        }
                    </div>
                </div>
                }

            </div>
            <!-- Product - END -->

            <!-- Product Details -->
            @if (!manualProductEntry() && slickOnboardService.productDetailsModel().productName &&
            slickOnboardService.productDetailsModel().productName.length > 0) {
            <div class="col-span-full">
                <label for="product-link" class="block text-sm/6 font-medium text-primary">Product Found</label>
                <div
                    class="mt-2 w-full rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50 p-4 flex flex-col gap-y-2">
                    <div class="sm:flex">
                        <div class="mb-4 shrink-0 sm:mr-4 sm:mb-0">
                            @if (slickOnboardService.productDetailsModel().productImage &&
                            slickOnboardService.productDetailsModel().productImage.length > 0) {
                            <img [src]="slickOnboardService.productDetailsModel().productImage" alt="Product Image"
                                class="h-32 w-full object-cover" />
                            } @else {
                            <div class="h-32 w-32 bg-gray-200 dark:bg-gray-900">
                                <atom-add-image [initialImage]="slickOnboardService.productDetailsModel().productImage"
                                    [bucket]="S3BucketEnum.PRODUCT_IMAGES" [size]="'sm'"
                                    (imageUploaded)="onImageUploaded($event)"></atom-add-image>
                            </div>
                            }
                        </div>
                        <div class="flex flex-col items-start justify-between">
                            <div>
                                <h4 class="text-md font-bold text-primary">{{
                                    slickOnboardService.productDetailsModel().productName }}</h4>
                                <p class="mt-1 text-sm text-secondary">{{
                                    slickOnboardService.productDetailsModel().productDescription }}
                                </p>
                            </div>

                            <div class="flex flex-row flex-wrap gap-4">
                                <h4 class="text-md font-bold text-primary">{{
                                    slickOnboardService.productDetailsModel().productPrice |
                                    currency:
                                    slickOnboardService.productDetailsModel().currency.toUpperCase() }}</h4>

                                <span
                                    class="inline-flex items-center rounded-md bg-primary/10 dark:bg-primary/15 px-2 py-1 text-xs font-medium text-accent inset-ring inset-ring-primary/35">{{
                                    slickOnboardService.productDetailsModel().productCategory }}</span>
                                <span
                                    class="inline-flex items-center rounded-md bg-primary/10 dark:bg-primary/15 px-2 py-1 text-xs font-medium text-accent inset-ring inset-ring-primary/35">{{
                                    slickOnboardService.productDetailsModel().productIndustry }}</span>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            }
            <!-- Product Details - END -->
            }
            <!-- Specific Product - END -->


            <!-- Content Distribution -->
            <div class="col-span-full">
                <label for="product-link" class="block text-sm/6 font-medium text-primary">Which platform is the content
                    for?</label>
                <ul role="list" class="mt-3 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    @for (channel of socialChannelOptions; track channel.channelId) {
                    @if (channel.channelId == -1) {

                    <li class="col-span-1 flex rounded-md" (click)="selectUgcOnly(channel)">
                        <div
                            class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-gray-200 dark:bg-gray-700 text-sm font-medium text-primary py-2">
                            <img [src]="channel.channelIcon" alt="" class="size-8" />
                        </div>
                        <div class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b cursor-pointer"
                            [class]="createBriefService.selectedUgcOnly() ? 'border-primary' : 'border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-gray-800/50'">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a class="font-medium text-primary hover:text-gray-700 dark:hover:text-gray-200">{{
                                    channel.channelName }}</a>

                            </div>

                        </div>
                    </li>

                    } @else {

                    <li class="col-span-1 flex rounded-md" (click)="selectInfluencerBrief(channel)">
                        <div
                            class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-gray-200 dark:bg-gray-700 text-sm font-medium text-primary py-2">
                            <img [src]="channel.channelIcon" alt="" class="size-8 rounded-md" />
                        </div>
                        <div class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b cursor-pointer"
                            [class]="isChannelSelected(channel) ? 'border-primary' : 'border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-gray-800/50'">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a class="font-medium text-primary hover:text-gray-700 dark:hover:text-gray-200">{{
                                    channel.channelName
                                    }}</a>
                            </div>

                        </div>
                    </li>
                    }
                    }
                </ul>
            </div>
            <!-- Content Distribution - END -->

        </div>

        @if (speedySetupFormMessage()) {
        <div role="alert"
            class="mt-4 w-full rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-900 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-100">
            <p class="m-0">{{ speedySetupFormMessage() }}</p>
        </div>
        }

        <button type="button" (click)="submitSpeedySetup()"
            class="mt-6 w-full sm:w-auto sm:min-w-40 text-center primary-go-button flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold min-h-11 touch-manipulation order-1 sm:order-2">

            <p class="block">Generate Brief</p>

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5 shrink-0">
                <path
                    d="m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72" />
                <path d="m14 7 3 3" />
                <path d="M5 6v4" />
                <path d="M19 14v4" />
                <path d="M10 2v2" />
                <path d="M7 8H3" />
                <path d="M21 16h-4" />
                <path d="M11 3H9" />
            </svg>

        </button>
    </div>
    }

    @else if (queryRunning() && !slickOnboardService.stepsHtml() && !savingBrief()) {
    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">
        <div class="relative flex flex-row gap-x-2 mb-4">
            <div class="beam-wrapper">
                <div class="icon" #RefItem1>
                    <div
                        class="size-10 rounded-full bg-zinc-300 dark:bg-white/10 p-2 dark:text-gray-400 text-gray-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-baby-icon lucide-baby">
                            <path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" />
                            <path d="M15 12h.01" />
                            <path
                                d="M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1" />
                            <path d="M9 12h.01" />
                        </svg>
                    </div>

                </div>
                <div class="icon" #RefItem2>
                    <div
                        class="size-10 rounded-full bg-zinc-300 dark:bg-white/10 p-2 dark:text-gray-400 text-gray-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-blocks-icon lucide-blocks">
                            <path
                                d="M10 22V7a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5a1 1 0 0 0-1-1H2" />
                            <rect x="14" y="2" width="8" height="8" rx="1" />
                        </svg>
                    </div>
                </div>
                <div class="icon" #RefItem3>
                    <div
                        class="size-10 rounded-full bg-zinc-300 dark:bg-white/10 p-2 dark:text-gray-400 text-gray-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-baggage-claim-icon lucide-baggage-claim">
                            <path d="M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2" />
                            <path d="M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10" />
                            <rect width="13" height="8" x="8" y="6" rx="1" />
                            <circle cx="18" cy="20" r="2" />
                            <circle cx="9" cy="20" r="2" />
                        </svg>
                    </div>
                </div>
                <div class="center">
                    <div class="icon" #RefCenter>
                        <div
                            class="h-12 w-12 rounded-full bg-primary/10 dark:bg-primary/50 p-2 text-gray-700 dark:text-gray-400 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-brain-icon lucide-brain">
                                <path d="M12 18V5" />
                                <path d="M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4" />
                                <path d="M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5" />
                                <path d="M17.997 5.125a4 4 0 0 1 2.526 5.77" />
                                <path d="M18 18a4 4 0 0 0 2-7.464" />
                                <path d="M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517" />
                                <path d="M6 18a4 4 0 0 1-2-7.464" />
                                <path d="M6.003 5.125a4 4 0 0 0-2.526 5.77" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="icon" #RefItem4>
                    <div
                        class="size-10 rounded-full bg-zinc-300 dark:bg-white/10 p-2 dark:text-gray-400 text-gray-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-cloud-sun-icon lucide-cloud-sun">
                            <path d="M12 2v2" />
                            <path d="m4.93 4.93 1.41 1.41" />
                            <path d="M20 12h2" />
                            <path d="m19.07 4.93-1.41 1.41" />
                            <path d="M15.947 12.65a4 4 0 0 0-5.925-4.128" />
                            <path d="M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z" />
                        </svg>
                    </div>
                </div>
                <div class="icon" #RefItem5>
                    <div
                        class="size-10 rounded-full bg-zinc-300 dark:bg-white/10 p-2 dark:text-gray-400 text-gray-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-gamepad2-icon lucide-gamepad-2">
                            <line x1="6" x2="10" y1="11" y2="11" />
                            <line x1="8" x2="8" y1="9" y2="13" />
                            <line x1="15" x2="15.01" y1="12" y2="12" />
                            <line x1="18" x2="18.01" y1="10" y2="10" />
                            <path
                                d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z" />
                        </svg>
                    </div>
                </div>
                <div class="icon" #RefItem6>
                    <div
                        class="size-10 rounded-full bg-zinc-300 dark:bg-white/10 p-2 dark:text-gray-400 text-gray-700 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-monitor-cog-icon lucide-monitor-cog">
                            <path d="M12 17v4" />
                            <path d="m14.305 7.53.923-.382" />
                            <path d="m15.228 4.852-.923-.383" />
                            <path d="m16.852 3.228-.383-.924" />
                            <path d="m16.852 8.772-.383.923" />
                            <path d="m19.148 3.228.383-.924" />
                            <path d="m19.53 9.696-.382-.924" />
                            <path d="m20.772 4.852.924-.383" />
                            <path d="m20.772 7.148.924.383" />
                            <path d="M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7" />
                            <path d="M8 21h8" />
                            <circle cx="18" cy="6" r="3" />
                        </svg>
                    </div>
                </div>

                <om-connection-beam [fromRef]="RefItem1" [toRef]="RefCenter" [curvature]="-20"
                    [pathWidth]="4"></om-connection-beam>
                <om-connection-beam [fromRef]="RefItem2" [toRef]="RefCenter" [pathWidth]="4"></om-connection-beam>
                <om-connection-beam [fromRef]="RefItem3" [toRef]="RefCenter" [curvature]="20"
                    [pathWidth]="4"></om-connection-beam>
                <om-connection-beam [fromRef]="RefItem4" [toRef]="RefCenter" [reverse]="true" [curvature]="-20"
                    [pathWidth]="4"></om-connection-beam>
                <om-connection-beam [fromRef]="RefItem5" [toRef]="RefCenter" [reverse]="true"
                    [pathWidth]="4"></om-connection-beam>
                <om-connection-beam [fromRef]="RefItem6" [toRef]="RefCenter" [reverse]="true" [curvature]="20"
                    [pathWidth]="4"></om-connection-beam>
            </div>
        </div>

        <!-- Chat Simulation -->
        <div
            class="flex-1 overflow-y-auto scrollbar-transparent border border-gray-200 dark:border-white/10 rounded-xl p-4 bg-gray-50 dark:bg-gray-900/50">
            <div class="flex flex-col space-y-4">
                @for (message of chatMessages(); track $index) {
                @if (message.displayedText || $index <= currentMessageIndex()) { <!-- AI Message -->
                    <div class="flex items-start gap-x-3">
                        <!-- AI Avatar -->
                        <div class="shrink-0 size-8 rounded-full bg-primary flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-white">
                                <path d="M12 8V4H8" />
                                <rect width="16" height="12" x="4" y="8" rx="2" />
                                <path d="M2 14h2" />
                                <path d="M20 14h2" />
                                <path d="M15 13v2" />
                                <path d="M9 13v2" />
                            </svg>
                        </div>
                        <!-- Message Bubble -->
                        <div class="flex-1 bg-gray-100 dark:bg-gray-800 rounded-lg rounded-tl-none p-4">
                            <p class="text-sm text-primary whitespace-pre-wrap">
                                <span>{{ message.displayedText }}</span>
                                @if ($index === currentMessageIndex() && !message.isComplete) {
                                <span
                                    class="inline-block w-2 h-4 bg-primary dark:bg-primary/75 animate-pulse ml-1">|</span>
                                }
                            </p>
                        </div>
                    </div>
                    <!-- AI Message - END -->
                    }
                    }
            </div>
        </div>
        <!-- Chat Simulation - END -->
    </div>
    }

    @else if (!queryRunning() && slickOnboardService.stepsHtml() && slickOnboardService.creativeConcepts().length > 0 &&
    slickOnboardService.doHtml() && slickOnboardService.dontHtml() && !savingBrief()) {
    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">

        <div
            class="w-1/2 mx-auto text-center inline-flex gap-x-2 items-center justify-center relative rounded-full px-3 py-1 text-md text-accent ring-1 ring-gray-300 dark:ring-white/10 hover:ring-gray-400 dark:hover:ring-white/20 mb-4">

            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path
                    d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z" />
                <path d="M20 2v4" />
                <path d="M22 4h-4" />
                <circle cx="4" cy="20" r="2" />
            </svg>
            AI Generated Brief.
        </div>


        <div
            class="divide-y divide-gray-200 dark:divide-white/10 overflow-hidden rounded-lg border border-gray-200 dark:border-white/10 bg-gray-100 dark:bg-zinc-800/50">
            <div class="px-4 py-5 sm:px-6">
                <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">

                    <div class="flex flex-row items-center">
                        <div class="shrink-0">

                            <div
                                class="size-16 rounded-full bg-gray-200 dark:bg-gray-800 outline -outline-offset-1 outline-gray-300 dark:outline-white/10 flex items-center justify-center overflow-hidden">
                                @if (focussedBrand?.companyLogo) {
                                <img [src]="imageService.getImageSource(focussedBrand.companyLogo, 'gallery')"
                                    alt="Company logo" class="size-full object-cover" />
                                } @else {
                                <p class="m-0 text-lg font-semibold text-accent" aria-hidden="true">
                                    {{ (focussedBrand?.companyName || 'B').charAt(0).toUpperCase() }}
                                </p>
                                }
                            </div>
                        </div>
                        <div class="ml-4">
                            <h3 class="text-base font-semibold text-primary">{{
                                slickOnboardService.promotingForm.briefTitle().value() }}</h3>
                            <div class="flex flex-row gap-x-2 items-center mt-1">
                                <span
                                    class="inline-flex items-center rounded-md bg-primary/10 dark:bg-primary/15 px-2 py-1 text-xs font-medium text-accent inset-ring inset-ring-primary/35">TikTok</span>

                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6 text-secondary">
                                    <circle cx="12.1" cy="12.1" r="1" />
                                </svg>

                                <p class="text-sm text-secondary">{{
                                    slickOnboardService.productDetailsModel().productName }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="flex shrink-0">
                        <button type="button" class="btn-fab-secondary" (click)="regenerateBrief()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5">
                                <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                                <path d="M21 3v5h-5" />
                                <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                                <path d="M8 16H3v5" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div class="px-4 py-5 sm:p-6 flex flex-col gap-y-4">
                <!-- Key Message -->
                <div class="flex flex-row gap-x-2">
                    <div class="flex-1">
                        <h4 class="text-md font-bold text-primary">Key Message</h4>
                        <div class="mt-2" [innerHTML]="slickOnboardService.stepsHtml()"></div>
                    </div>
                </div>
                <!-- Key Message - END -->

                <!-- Creative Concepts -->
                <div class="flex-1">
                    <h4 class="text-md font-bold text-primary">Creative Concepts</h4>
                    <ul class="flex flex-col gap-2 mt-2">
                        @for (concept of slickOnboardService.creativeConcepts(); track concept.id) {
                        <div
                            class="w-full rounded-lg border border-primary/25 dark:border-primary/10 bg-primary/10 dark:bg-primary/20 p-2 flex flex-row gap-x-2 items-center justify-between">
                            <div>
                                <h4 class="text-sm font-bold text-primary">{{ concept.name }}</h4>
                                <p class="text-sm text-secondary">{{ concept.description }}</p>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6 text-accent">
                                    <path d="M20 6 9 17l-5-5" />
                                </svg>
                            </div>
                        </div>
                        }
                    </ul>
                </div>

                <!-- Creative Concepts - END -->

                <!-- Do's & Don't's -->
                <div class="w-full grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <!-- Do -->
                    <article class="flex flex-col">
                        <label class="block text-md font-bold text-green-600 dark:text-green-500">Do's</label>
                        <div [innerHTML]="slickOnboardService.doHtml()"></div>
                    </article>
                    <!-- Do - END -->
                    <!-- Don't -->
                    <article class="flex flex-col">
                        <label class="block text-md font-bold text-red-600 dark:text-red-500">Don't's</label>
                        <div [innerHTML]="slickOnboardService.dontHtml()"></div>
                    </article>
                    <!-- Don't - END -->
                </div>
                <!-- Do's & Don't's - END -->
            </div>
        </div>

        <div class="w-full flex flex-row items-center gap-x-2 mt-2">

            <button type="button" (click)="submitBrief()"
                class="flex-1 text-center primary-go-button flex flex-row items-center gap-x-4 justify-center rounded-md px-4 py-3 sm:py-1.5 text-base sm:text-sm font-semibold min-h-11 touch-manipulation">

                <p class="block">Looks Good!</p>

                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5 shrink-0">
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                </svg>

            </button>

            <button type="button" class="shrink-0 btn-fab-secondary text-secondary" (click)="regenerateBrief()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" />
                    <path d="M21 3v5h-5" />
                    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" />
                    <path d="M8 16H3v5" />
                </svg>
            </button>

        </div>

        <div class="w-3/4 flex flex-row items-center gap-x-2 mt-2 mx-auto">
            <p class="text-sm text-secondary text-center">You can regenerate this brief as many times as you like. Once
                you've moved to the next step, you're able to update your brief as much as you need to.</p>
        </div>





    </div>
    }

    @else if (savingBrief()) {
    <div class="w-full max-w-4xl flex flex-col gap-y-2 py-6 sm:py-8">
        <!-- Chat Simulation -->
        <div
            class="flex-1 overflow-y-auto scrollbar-transparent border border-gray-200 dark:border-white/10 rounded-xl p-4 bg-gray-50 dark:bg-gray-900/50">
            <div class="flex flex-col space-y-4">
                @for (message of chatMessages(); track $index) {
                @if (message.displayedText || $index <= currentMessageIndex()) { <!-- AI Message -->
                    <div class="flex items-start gap-x-3">
                        <!-- AI Avatar -->
                        <div class="shrink-0 size-8 rounded-full bg-primary flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-5 text-white">
                                <path d="M12 8V4H8" />
                                <rect width="16" height="12" x="4" y="8" rx="2" />
                                <path d="M2 14h2" />
                                <path d="M20 14h2" />
                                <path d="M15 13v2" />
                                <path d="M9 13v2" />
                            </svg>
                        </div>
                        <!-- Message Bubble -->
                        <div class="flex-1 bg-gray-100 dark:bg-gray-800 rounded-lg rounded-tl-none p-4">
                            <p class="text-sm text-primary whitespace-pre-wrap">
                                <span>{{ message.displayedText }}</span>
                                @if ($index === currentMessageIndex() && !message.isComplete) {
                                <span
                                    class="inline-block w-2 h-4 bg-primary dark:bg-primary/75 animate-pulse ml-1">|</span>
                                }
                            </p>
                        </div>
                    </div>
                    <!-- AI Message - END -->
                    }
                    }
            </div>
        </div>
        <!-- Chat Simulation - END -->
    </div>
    }
</div>